import { render, staticRenderFns } from "./InventoryOptimizationHome.vue?vue&type=template&id=aa25eeac"
import script from "./InventoryOptimizationHome.vue?vue&type=script&lang=js"
export * from "./InventoryOptimizationHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports